import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/hooks/store/useAuth";

export const useIsAuthenticated = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();

  useEffect(() => {
    switch (authState) {
      case "authenticated":
        break;
      case "unverified":
        navigate("/verify");
        break;
      default:
        navigate("/login");
        break;
    }
  }, [navigate, authState]);
};
